import { useEffect } from 'react'
import { NavigateOptions, useNavigate } from 'react-router'

export const NAVIGATION_EVENT = 'navigationEvent'

export const NavigateEventListener = () => {
  const navigate = useNavigate()

  useEffect(() => {
    function navigateListener(event: CustomEvent) {
      const to: string = event.detail.to
      const options: NavigateOptions | undefined = event.detail.options

      navigate(to, options)
    }

    document.addEventListener(NAVIGATION_EVENT, navigateListener)

    return () => {
      document.removeEventListener(NAVIGATION_EVENT, navigateListener)
    }
  }, [navigate])

  return null
}
